export default __webpack_public_path__ + "static/pragicts-featured-projects-39ea75f32b4f09d825370063e768a791.jpg";